export default (time: string): number => {
  const matches = time.match(/(\d\d):(\d\d)/)

  if (matches && matches.length === 3) {
    return 60 * parseInt(matches[1]) + parseInt(matches[2])
  }

  return 0
}
